export function getEanCheckNumber (e: string): string {
  if (!/^\d+$/.test(e)) return e
  const len = e.length

  if (len === 13 || len === 8 || len === 5) return e[len - 1]
  if (!(len === 12 || len === 7 || len === 4)) return e

  const weights = (len % 2) ? [1,3] : [3,1]
  let sum = 0
  for (let i = 0; i < len; i++)
    sum += (e.charCodeAt(i) - 48) * weights[i % 2]

  return `${(10 - (sum % 10)) % 10}`
}

export function validateEan (string) {
  const checkSum = getEanCheckNumber(String(string))
  return {valid: parseInt(checkSum) >= 0 && parseInt(checkSum) <= 9, checkSum, string: `${string}${checkSum === string ? '' : checkSum}`}
}

export default {
  checkSum: getEanCheckNumber,
  validate: validateEan
}
